export function throttle (fn, delay) {
    let lastExec = 0, cancelled = false

    // 取消后，该函数不可继续执行
    function cancel () {
        cancelled = true
    }
    // 重置定时器时间
    function restore () {
        lastExec = 0
    }

    function wrapper () {
        if (cancelled) return

        const [context, elapsed, args] = [this, Date.now() - lastExec, arguments]

        if (delay < elapsed) {
            lastExec = Date.now()
            fn.call(context, ...args)
        }
    }

    wrapper.cancel = cancel
    wrapper.restore = restore

    return wrapper
}
